var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 6c.075 0 .147.02.215.06.067.041.118.104.151.188l.915 2.274 2.357.216a.41.41 0 01.216.094c.052.048.093.11.12.186a.4.4 0 01-.113.444l-1.785 1.62.536 2.408a.37.37 0 01-.015.247.455.455 0 01-.142.181.402.402 0 01-.206.08.36.36 0 01-.226-.058L12 12.661l-2.022 1.28a.36.36 0 01-.227.057.402.402 0 01-.206-.08.455.455 0 01-.142-.18.37.37 0 01-.015-.248l.536-2.408-1.785-1.62a.407.407 0 01-.114-.444.464.464 0 01.121-.186.41.41 0 01.216-.094l2.357-.216.915-2.274a.366.366 0 01.151-.187C11.853 6.02 11.925 6 12 6z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 2a1 1 0 011 1v18.099a1 1 0 01-1.44.899l-.126-.075-5.868-4.033a1 1 0 00-1.132 0l-5.868 4.033A1 1 0 014 21.099V3a1 1 0 011-1h14zM5.5 20.148l5.084-3.495.163-.102a2.5 2.5 0 012.669.102l5.084 3.495V3.5h-13v16.648z",
    fill: "currentColor"
  })));
}
SvgFeatured.displayName = 'Featured';
export default SvgFeatured;